import { useLayoutEffect, useRef, useState } from "react"

const useDisplayFoodBottomLine = (brand?: string) => {
  const tagRef = useRef<HTMLDivElement>(null)
  const unitRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const brandRef = useRef<HTMLDivElement>(null)

  const [brandMaxWidth, setBrandMaxWidth] = useState("auto")
  const [unitMaxWidth, setUnitMaxWidth] = useState("auto")

  useLayoutEffect(() => {
    const GAPS_TOTAL = 10
    const MIN_BRAND_WIDTH = 50
    const PADDING = 0

    const tagWidth = tagRef.current?.clientWidth || 0
    const unitWidth = unitRef.current?.clientWidth || 0
    const brandWidth = brandRef.current?.clientWidth || 0
    const containerWidth = containerRef.current?.clientWidth || 0

    if (!containerWidth) return

    const availableWidth = containerWidth - GAPS_TOTAL - PADDING
    const totalNeededWidth = tagWidth + unitWidth + brandWidth

    // If everything fits, no need to adjust
    if (totalNeededWidth <= availableWidth) {
      return
    }

    const availableForUnitAndBrand = availableWidth - tagWidth

    // If no brand, give all space to unit
    if (!brand) {
      setUnitMaxWidth(`${availableForUnitAndBrand}px`)
      return
    }

    // Step 1: Try collapsing brand to minimum (50px)
    const spaceAfterMinBrand = availableForUnitAndBrand - MIN_BRAND_WIDTH

    if (unitWidth <= spaceAfterMinBrand) {
      // Unit fits after collapsing brand to minimum
      // Now try to expand brand as much as possible
      const extraSpace = spaceAfterMinBrand - unitWidth
      const finalBrandWidth = MIN_BRAND_WIDTH + extraSpace

      const TOLERANCE = 2

      setUnitMaxWidth(`${unitWidth + TOLERANCE}px`)
      setBrandMaxWidth(`${finalBrandWidth - TOLERANCE}px`)
    } else {
      // Unit doesn't fit even with minimum brand
      // Keep brand at minimum and collapse unit
      setUnitMaxWidth(`${spaceAfterMinBrand}px`)
      setBrandMaxWidth(`${MIN_BRAND_WIDTH}px`)
    }
  }, [brand])

  return {
    tagRef,
    unitRef,
    containerRef,
    brandRef,
    brandMaxWidth,
    unitMaxWidth,
  }
}

export default useDisplayFoodBottomLine